export default __webpack_public_path__ + "static/media/hubspot.5bb8e7d6.svg";